export default {
  namespaced: true,

  getters: {
    getATypeIcon: (_, __, ___, rootGetters) => id => rootGetters['apis/getObjProp']({ id, key: 'addressTypes', prop: 'icon' }),
  },
}
